import { useContext } from 'react';
import { AppContext } from './AppContext';

export const reAdd = (map, toggle, l) => {
    if (map.getLayer(l.id)) map.removeLayer(l.id);
    if (map.getSource(l.id)) map.removeSource(l.id);
    if (toggle) {
        if (l.type === 'raster') map.addLayer(l, "road-label")
        else map.addLayer(l);
    }
}

export const useLayerToggle = () => {
  const { mapboxRef } = useContext(AppContext);
  
  const layerToggle = layers => (toggle) => {
    if (!mapboxRef.current) return;
    layers.forEach(l => {
        reAdd(mapboxRef.current, toggle, l);
    });
  }

  return layerToggle;
}


const mapserver = ({ id, url }) => {
    return [{
        'id': id,
        'type': 'raster',
        'source': {
            'type': 'raster',
            'tiles': [
                url
            ],
            'tileSize': 256
        },
        'paint': {}
    }];
}


export const exportParams = '/export?dpi=96&transparent=true&format=png32&bbox={bbox-epsg-3857}&bboxSR=3857&imageSR=3857&size=256%2C256&f=image&layers=show:';


const layers = [
    mapserver({
        id: 'Flood Hazard Zones NFHL',
        url: 'https://hazards.fema.gov/gis/nfhl/rest/services/public/NFHL/MapServer/export?dpi=96&transparent=true&format=png32&bbox={bbox-epsg-3857}&bboxSR=3857&imageSR=3857&size=256%2C256&f=image&0=?&1=f&2==&3=j&4=s&5=o&6=n&layers=show:28'
    }),
    // mapserver({
    //     id: 'High Water Marks public/NFHL',
    //     url: 'https://hazards.fema.gov/gis/nfhl/rest/services/public/NFHL/MapServer/export?dpi=96&transparent=true&format=png32&bbox={bbox-epsg-3857}&bboxSR=3857&imageSR=3857&size=256%2C256&f=image&0=?&1=f&2==&3=j&4=s&5=o&6=n&layers=show:12'
    // }),
    // mapserver({
    //     id: 'Base Flood Elevations public/NFHL',
    //     url: 'https://hazards.fema.gov/gis/nfhl/rest/services/public/NFHL/MapServer/export?dpi=96&transparent=true&format=png32&bbox={bbox-epsg-3857}&bboxSR=3857&imageSR=3857&size=256%2C256&f=image&0=?&1=f&2==&3=j&4=s&5=o&6=n&layers=show:16'
    // }),
    mapserver({
        id: 'Wetlands fws.gov',
        url: 'https://www.fws.gov/wetlands/arcgis/rest/services/Wetlands/MapServer/export?dpi=96&transparent=true&format=png32&bbox={bbox-epsg-3857}&bboxSR=3857&imageSR=3857&size=256%2C256&f=image&0=?&1=f&2==&3=j&4=s&5=o&6=n&layers=show:0'
    }),
    [{
        'id': 'GroundWaterWatch.USGS.gov',
        'type': 'circle',
        'source': {
            'type': 'geojson',
            'data': 'https://storage.googleapis.com/acretrader-ds.appspot.com/data/awl_wells.json'
        },
        'paint': {
            'circle-color': 'blue'
        }
    }, {
        'id': 'GroundWaterWatch.USGS.gov - label',
        'type': 'symbol',
        'source': {
            'type': 'geojson',
            'data': 'https://storage.googleapis.com/acretrader-ds.appspot.com/data/awl_wells.json'
        },
        'layout': {
            'text-field': '{DATA_VAL} ft'
        },
        'paint': {
            'text-color': 'white',
            'text-halo-width': 1,
            'text-halo-color': 'black'
        }
    }],
    mapserver({
        id: 'Elevation 3DEP USGS',
        url: 'https://elevation.nationalmap.gov/arcgis/rest/services/3DEPElevation/ImageServer/exportImage?dpi=96&transparent=true&format=png32&bbox={bbox-epsg-3857}&bboxSR=3857&imageSR=3857&size=256%2C256&f=image&layers='
    }),
    mapserver({
        id: 'NAIP Latest',
        // historical sentinel and landsat https://landlook.usgs.gov/arcgis/rest/services/Combined
        // OR historical naip https://services.nationalmap.gov/arcgis/rest/services/USGSNAIPImagery/ImageServer
        // OR WMS which allows query, but this only only has one year per location? https://gis.apfo.usda.gov/arcgis/services/NAIP/USDA_CONUS_PRIME/ImageServer/WMSServer?LAYERS=0&STYLES=&FORMAT=image/jpeg&TRANSPARENT=TRUE&CRS=3857&WIDTH=256&HEIGHT=256&BBOX=-9739911.8922103,4471260.406569671,-9735019.922400048,4476152.376379922&VERSION=1.3.0&SERVICE=WMS&REQUEST=GetMap&Query=Year_ts=2020
        url: 'https://gis.apfo.usda.gov/arcgis/rest/services/NAIP/USDA_CONUS_PRIME/ImageServer/exportImage?dpi=96&transparent=true&format=png32&bbox={bbox-epsg-3857}&bboxSR=3857&imageSR=3857&size=256%2C256&f=image'
    }),
    mapserver({
        id: 'USGS National Hydrography Dataset',
        url: 'https://hydro.nationalmap.gov/arcgis/rest/services/nhd/MapServer' + exportParams,
    }),
    mapserver({ 
        id: 'PLSS',
        url: 'https://gis.blm.gov/arcgis/rest/services/Cadastral/BLM_Natl_PLSS_CadNSDI/MapServer' + exportParams
    }),
    // TODO need a proxy
    // california
    // https://waterrightsmaps.waterboards.ca.gov/gisapp/rest/services/eWRIMS/water_rights/MapServer/0
    // https://waterrightsmaps.waterboards.ca.gov/gisapp/rest/services/eWRIMS/natural_resources/MapServer/3
    // https://waterrightsmaps.waterboards.ca.gov/gisapp/rest/services/GRS/GRS/MapServer
    // https://waterrightsmaps.waterboards.ca.gov/gisapp/rest/services/eWRIMS/HUCs/MapServer/0
    // welstrom wetlands recharge rivers
    // https://www.welstrom.com/welstrom/rest/services/wetlands_recharge_rivers/MapServer
    // https://www.welstrom.com/welstrom/rest/services/DHDSource_Well/MapServer
    // mapserver({
    //     id: 'Welstrom wetlands recharge rivers',
    //     'url': 'https://www.welstrom.com/welstrom/rest/services/wetlands_recharge_rivers/MapServer' + exportParams
    // }),
    // mapserver({
    //     id: 'NDVI - Esri NAIP',
    //     url: 'https://naip.arcgis.com/arcgis/rest/services/NAIP/ImageServer/exportImage?f=image&bbox={bbox-epsg-3857}&bboxSR=102100&imageSR=102100&size=256,256&format=jpgpng&mosaicRule={"ascending":true,"mosaicMethod":"esriMosaicAttribute","mosaicOperation":"MT_FIRST","sortField":"Year","sortValue":"3000"}&renderingRule={"rasterFunction":"NDVI_Color"}&token=' + ESRI_TOKEN
    // }),
    [
      {
        "id": "Contours",
        "type": "symbol",
        "paint": {
          "text-color": "black",
          "text-halo-color": "rgba(255,255,255,0.8)",
          "text-halo-width": 2
        },
        "layout": {
          "text-size": {
            "base": 1,
            "stops": [
              [
                9,
                9
              ],
              [
                14,
                12
              ]
            ]
          },
          "text-field": [
            "concat",
            [
              "to-string",
              [
                "round",
                [
                  "*",
                  [
                    "get",
                    "ele"
                  ],
                  3.28
                ]
              ]
            ],
            "ft"
          ],
          "symbol-placement": "line",
          "text-rotation-alignment": "map"
        },
        "source": {
          "url": "mapbox://mapbox.mapbox-terrain-v2",
          "type": "vector"
        },
        "source-layer": "contour"
      },
      {
        "id": "Contours-lines",
        "type": "line",
        "paint": {
          "line-color": "white"
        },
        "source": {
          "url": "mapbox://mapbox.mapbox-terrain-v2",
          "type": "vector"
        },
        "source-layer": "contour"
      }
    ],
    [{id: 'Planet 2019 Feb', type: 'raster', source: {type: 'raster', tiles: ['https://tiles0.planet.com/basemaps/v1/planet-tiles/global_monthly_2019_02_mosaic/gmap/{z}/{x}/{y}.png?api_key=06f0282c2c004b61925a0d65b47edf6f']}}],
    [{id: 'Planet 2018 Sep', type: 'raster', source: {type: 'raster', tiles: ['https://tiles0.planet.com/basemaps/v1/planet-tiles/global_monthly_2018_09_mosaic/gmap/{z}/{x}/{y}.png?api_key=06f0282c2c004b61925a0d65b47edf6f']}}],
]


export const mapboxSatellite = [{
    id: 'mapbox-satellite',
    type: 'raster',
    source: {
        type: 'raster',
        url: 'mapbox://mapbox.satellite',
        tileSize: 256
    }
}]

export default layers;
